export default __webpack_public_path__ + "static/media/calendar2.5bfc6e97.svg";